import { from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { getGisToken } from '@app/modules/gis/gis-token';
import { GIS_PORTAL_BASE } from '@app/modules/gis/gis-config';
/**
 * Appends the GIS Portal access token as a `token` query parameter to every
 * HttpClient request targeting gis.xom.cloud (portal, MapServer, FeatureServer
 * REST endpoints). Awaits a silent refresh if the token is expired so the
 * request always uses a valid token.
 */
var GisTokenInterceptor = /** @class */ (function () {
    function GisTokenInterceptor() {
        this.gisPortalOrigin = new URL(GIS_PORTAL_BASE).origin;
    }
    GisTokenInterceptor.prototype.intercept = function (request, next) {
        if (!this.isGisPortalRequest(request.url)) {
            return next.handle(request);
        }
        return from(getGisToken()).pipe(switchMap(function (token) {
            if (!token) {
                return next.handle(request);
            }
            var cloned = request.clone({
                params: request.params.set('token', token)
            });
            return next.handle(cloned);
        }));
    };
    GisTokenInterceptor.prototype.isGisPortalRequest = function (url) {
        try {
            var currentOrigin = typeof window !== 'undefined' ? window.location.origin : 'http://localhost';
            return new URL(url, currentOrigin).origin === this.gisPortalOrigin;
        }
        catch (_a) {
            return false;
        }
    };
    return GisTokenInterceptor;
}());
export { GisTokenInterceptor };
